import { useEffect, useState } from "react";
import { useGame } from "~/app";
import { TurnPhase } from "~/business";
import { ModalNames } from "~/jsx/context/ModalNames";
import { useViewingPlayerOpt } from "~/jsx/hook";
import { useModal } from "~/utils";
import { XDesignModal } from "../design/XDesignModal";
import { XShop } from "./XShop";

export const XShopModal = () => {
  const { game } = useGame();
  const { turnPhase, currentPlayer } = game;
  const [lastTurnPhase, setLastTurnPhase] = useState(turnPhase);
  const [lastPlayerId, setLastPlayerId] = useState(currentPlayer.id);
  const { show: showShop, hide: hideShop } = useModal(ModalNames.shop);
  const viewingPlayer = useViewingPlayerOpt();
  useEffect(() => {
    if (
      turnPhase === TurnPhase.Shop &&
      viewingPlayer?.id === currentPlayer.id
    ) {
      showShop();
    }
  }, []);
  useEffect(() => {
    if (turnPhase !== lastTurnPhase || lastPlayerId !== currentPlayer.id) {
      if (
        viewingPlayer?.id === currentPlayer.id &&
        turnPhase === TurnPhase.Shop
      ) {
        showShop();
      } else if (
        lastTurnPhase === TurnPhase.Shop &&
        lastPlayerId === viewingPlayer?.id
      ) {
        hideShop();
      }
      setLastTurnPhase(turnPhase);
      setLastPlayerId(currentPlayer.id);
    }
  }, [turnPhase, lastTurnPhase, currentPlayer.id, lastPlayerId]);

  return (
    <XDesignModal name={ModalNames.shop} title="Shop">
      <XShop />
    </XDesignModal>
  );
};
